import * as events from './events'
import { integrations, integrationsToDisplayName } from './integrations'

/**
 * @typedef {Object} TrackingOptions
 * @property {boolean} sequential - is
 * @property {Object} passThrough
 * @property {Object} tracking
 * @property {boolean} tracking.perspective
 * @property {boolean} tracking.integrations
 * @property {Object} middlewares
 */
const options = {
  /**
   *
   * @type {{sequential : boolean, passThrough : {}, tracking : {perspective : boolean, integrations : boolean}, middlewares: {}}}
   */
  [events.formEvent]: {
    sequential: false,
    passThrough: {
      integrations: {
        [integrationsToDisplayName[integrations.facebookPixel]]: false,
      },
    },
    tracking: {
      perspective: false,
      integrations: true,
    },
    middlewares: {
      [integrationsToDisplayName[integrations.adwords]]: null,
      [integrationsToDisplayName[integrations.facebookPixel]]: null,
      [integrationsToDisplayName[integrations.googleAnalytics]]: null,
      [integrationsToDisplayName[integrations.googleTagManager]]: null,
      [integrationsToDisplayName[integrations.hubspot]]: null,
    },
  },
  [events.interactionFormEvent]: {
    sequential: true,
    passThrough: {},
    tracking: {
      perspective: true,
      integrations: false,
    },
    middlewares: {
      [integrationsToDisplayName[integrations.adwords]]: null,
      [integrationsToDisplayName[integrations.facebookPixel]]: null,
      [integrationsToDisplayName[integrations.googleAnalytics]]: null,
      [integrationsToDisplayName[integrations.googleTagManager]]: null,
      [integrationsToDisplayName[integrations.hubspot]]: null,
    },
  },
  [events.interactionQuestionEvent]: {
    sequential: true,
    passThrough: {},
    tracking: {
      perspective: true,
      integrations: false,
    },
    middlewares: {
      [integrationsToDisplayName[integrations.adwords]]: null,
      [integrationsToDisplayName[integrations.facebookPixel]]: null,
      [integrationsToDisplayName[integrations.googleAnalytics]]: null,
      [integrationsToDisplayName[integrations.googleTagManager]]: null,
      [integrationsToDisplayName[integrations.hubspot]]: null,
    },
  },
  [events.interactionQuestionMultipleChoiceEvent]: {
    sequential: true,
    passThrough: {},
    tracking: {
      perspective: true,
      integrations: false,
    },
    middlewares: {
      [integrationsToDisplayName[integrations.adwords]]: null,
      [integrationsToDisplayName[integrations.facebookPixel]]: null,
      [integrationsToDisplayName[integrations.googleAnalytics]]: null,
      [integrationsToDisplayName[integrations.googleTagManager]]: null,
      [integrationsToDisplayName[integrations.hubspot]]: null,
    },
  },
  [events.answerEvent]: {
    sequential: false,
    passThrough: {},
    tracking: {
      perspective: false,
      integrations: true,
    },
    middlewares: {
      [integrationsToDisplayName[integrations.adwords]]: null,
      [integrationsToDisplayName[integrations.facebookPixel]]: null,
      [integrationsToDisplayName[integrations.googleAnalytics]]: null,
      [integrationsToDisplayName[integrations.googleTagManager]]: null,
      [integrationsToDisplayName[integrations.hubspot]]: null,
    },
  },
  [events.metaEvent]: {
    sequential: true,
    passThrough: {},
    tracking: {
      perspective: true,
      integrations: false,
    },
    middlewares: {
      [integrationsToDisplayName[integrations.adwords]]: null,
      [integrationsToDisplayName[integrations.facebookPixel]]: null,
      [integrationsToDisplayName[integrations.googleAnalytics]]: null,
      [integrationsToDisplayName[integrations.googleTagManager]]: null,
      [integrationsToDisplayName[integrations.hubspot]]: null,
    },
  },
  [events.buttonEvent]: {
    sequential: false,
    passThrough: {},
    tracking: {
      perspective: false,
      integrations: true,
    },
    middlewares: {
      [integrationsToDisplayName[integrations.adwords]]: null,
      [integrationsToDisplayName[integrations.facebookPixel]]: null,
      [integrationsToDisplayName[integrations.googleAnalytics]]: null,
      [integrationsToDisplayName[integrations.googleTagManager]]: null,
      [integrationsToDisplayName[integrations.hubspot]]: null,
    },
  },
}

export default options
